import {AlertBanner} from '@resurs-internal/mui';
import {isRestError} from '@resurs-internal/rb-app-api';
import {useTranslate} from 'hooks';
import React from 'react';
import {isYearlyWithdrawalLimitError} from './utils/isYearlyWithdrawalLimitError';

export const SavingsAccountWithdrawalAlertBanner: React.FC<{
  error: unknown;
}> = ({error}) => {
  const translate = useTranslate();

  if (!error) return null;

  const code = isRestError(error) ? error.code : undefined;
  const status = isRestError(error) ? error.status : undefined;

  if (code === 'withdrawal_not_permitted') {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate('savings.send-money.errors.not-permitted')}
      />
    );
  }

  if (code === 'withdrawal_limit_reached') {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate('savings.send-money.errors.limit-reached')}
      />
    );
  }

  if (code === 'not_enough_funds') {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate('savings.send-money.errors.not-enough-funds')}
      />
    );
  }

  if (code === 'illegal_destination_account') {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate('savings.send-money.errors.illegal-destination')}
      />
    );
  }

  if (code === '400') {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate('savings.send-money.errors.invalid-message')}
      />
    );
  }

  if (code === 'corporate_limit_per_withdrawal') {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate(
          'savings.send-money.errors.limit-reached.corporate.title',
        )}
        subtitle={translate(
          'savings.send-money.errors.limit-reached.corporate.subtitle',
        )}
      />
    );
  }

  if (isRestError(error) && isYearlyWithdrawalLimitError(error.message)) {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate('savings.send-money.errors.limit-reached')}
      />
    );
  }

  if (status === 409) {
    return (
      <AlertBanner
        severity={'warning'}
        title={translate('savings.send-money.errors.duplicate-signature')}
      />
    );
  }

  return (
    <AlertBanner
      severity={'warning'}
      title={translate('savings.send-money.errors.generic')}
      subtitle={`${error}`}
    />
  );
};
